import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ButtonGhost from '../ButtonGhost';
import ChevronDown from '../icons/ChevronDown';
import ChevronUp from '../icons/ChevronUp';

const VideoCard = ({ video, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const MAX_CHARS = 110;
  const description = video.description || '';
  const needsTruncation = description.length > MAX_CHARS;
  const truncatedText = needsTruncation
    ? description.substring(0, MAX_CHARS).trim() + '...'
    : description;

  return (
    <GuideCard>
      <LoomVideo videoId={video.loomId} />
      <VideoContent>
        <VideoLabel>FilmChain CAM Guides</VideoLabel>
        <VideoCardTitle>{video.title}</VideoCardTitle>
        {description && (
          <VideoCardDescription>{isExpanded ? description : truncatedText}</VideoCardDescription>
        )}
      </VideoContent>
      {needsTruncation && (
        <ButtonGhost
          size="sm"
          renderIcon={isExpanded ? ChevronUp : ChevronDown}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Show less' : 'Show more'}
        </ButtonGhost>
      )}
    </GuideCard>
  );
};

VideoCard.propTypes = {
  video: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

const LoomVideo = ({ videoId }) => {
  const embedUrl = `https://www.loom.com/embed/${videoId}`;

  return (
    <VideoContainer>
      <VideoWrapper>
        <VideoIframe src={embedUrl} webkitallowfullscreen mozallowfullscreen allowFullScreen />
      </VideoWrapper>
    </VideoContainer>
  );
};

LoomVideo.propTypes = {
  videoId: PropTypes.string.isRequired,
};

export default VideoCard;

const VideoContainer = styled.div`
  display: flex;
  width: 100%;
  height: 340.776px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  aspect-ratio: 552/340.78;

  @media screen and (max-width: 768px) {
    height: 193.847px;
    aspect-ratio: 314/193.85;
  }
`;

const VideoWrapper = styled.div`
  width: 552px;
  height: 340.776px;
  aspect-ratio: 552/340.78;
  overflow: hidden;
  background: #000;
  border-radius: 4px;

  @media screen and (max-width: 768px) {
    height: 193.847px;
    aspect-ratio: 314/193.85;
  }
`;

const VideoIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;

const GuideCard = styled.div`
  display: flex;
  min-width: 352px;
  max-width: 600px;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  border-radius: 16px;
  border: 1px solid #dedbdf;
  background: #fff;
  @media screen and (max-width: 768px) {
    min-width: 280px;
  }
  &:hover {
    background: #f3f2f3;
    box-shadow: 0 56px 16px 0 rgba(0, 0, 0, 0), 0 36px 14px 0 rgba(0, 0, 0, 0.01),
      0 20px 12px 0 rgba(0, 0, 0, 0.02), 0 9px 9px 0 rgba(0, 0, 0, 0.04),
      0 2px 5px 0 rgba(0, 0, 0, 0.05);
  }
`;

const VideoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const VideoLabel = styled.p`
  font-size: 12px;
  font-style: normal;
  color: #db6e6b;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.32px;
`;

const VideoCardTitle = styled.h3`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  color: #000;
`;

const VideoCardDescription = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #68636a;
`;
